import { Form, Input, Button, Modal } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Chat.css';

export default function Chat() {
    const [form] = Form.useForm();
    const language = localStorage.getItem('language');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const navigate = useNavigate();

    // Xử lý xác nhận mã tư vấn
    const handleCheckgroupid = async (value) => {
        try {
            if (!value.groupid) {
                setModalMessage(language === '1' ? 'Chat code is required!' : 'Cần nhập mã tư vấn!');
                setIsModalVisible(true);
                return;
            }
            // Gọi API getgroupmessage để kiểm tra mã tư vấn
            const res = await fetch(`${process.env.REACT_APP_API_SERVER_URL}/chat/getgroupdetail/${value.groupid}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });
            const data = await res.json();
            if (!data.status) {
                navigate(`/chat/${value.groupid}`);
            } else {
                setModalMessage(language === '1' ? 'Invalid chat code!' : 'Mã tư vấn không hợp lệ!');
                setIsModalVisible(true);
            }
        } catch (error) {
            setModalMessage(language === '1' ? 'An error occurred!' : 'Đã có lỗi xảy ra!');
            setIsModalVisible(true);
        }
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
        setModalMessage('');
    };

    return (
        <div className="chat-container">
            <div className="chat-content">
                <h1 className='chat-head-label'>
                    {language === '1' ? 'Chat Support' : 'Tư vấn đặt xe'}
                </h1>
                <Form
                    form={form}
                    name="check-chat"
                    onFinish={handleCheckgroupid}
                    layout="vertical"
                    className='chat-form'
                >
                    <h4 className='chat-label'>{language === '1' ? 'Chat Code' : 'Mã tư vấn'}</h4>
                    <Form.Item
                        name="groupid"
                        className='chat-form-input'
                        rules={[{ required: true, message: language === '1' ? 'Chat code is required!' : 'Cần nhập mã tư vấn!' }]}
                    >
                        <Input className='chat-input' type='text' placeholder={language === '1' ? 'Chat code' : 'Mã tư vấn'} />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" className='chat-submit-button'>
                            {language === '1' ? 'Confirm' : 'Xác nhận'}
                        </Button>
                    </Form.Item>
                </Form>
                <div className="create-new-chat" style={{ marginTop: 16 }}>
                    <a
                        href="#"
                        style={{ color: '#1976d2', fontWeight: 700, fontSize: 16 }}
                        onClick={e => {
                            e.preventDefault();
                            navigate('/chat/new');
                        }}
                    >
                        {language === '1' ? 'Create new chat session' : 'Tạo phiên tư vấn mới'}
                    </a>
                </div>
                <Modal
                    title={null}
                    open={isModalVisible}
                    onCancel={handleCloseModal}
                    width={400}
                    closable={false}
                    footer={null}
                    centered={true}
                    className="contact-modal"
                    mask={true}
                    maskStyle={{ backgroundColor: "white", top: '64px' }}
                    style={{ backgroundColor: 'transparent', marginTop: `64px` }}
                    bodyStyle={{ padding: 0 }}
                    wrapClassName="transparent-modal-wrapper"
                    getContainer={() => document.querySelector('.chat-content')}
                >
                    <div className="finish-icon">
                        <img src="/Image/BookingPage/Icon/Group 15 (2).png" alt="finish-icon" />
                    </div>
                    <h2 className="success">{modalMessage.includes('hợp lệ') || modalMessage.includes('Valid') ? (language === '1' ? 'Success!' : 'Thành công!') : (language === '1' ? 'Sorry!' : 'Xin lỗi!')}</h2>
                    <p className="text-finish">{modalMessage}</p>
                    <Button onClick={handleCloseModal} className="chat-confirm-button">
                        OK
                    </Button>
                </Modal>
            </div>
        </div>
    );
}
